import _ from "lodash"

export const levelEvaluationByTokenSelector = levelEvaluationToken => state => {
  return _.get(state.levelEvaluationByToken, levelEvaluationToken, {})
}
